import React from "react";
import { Checkbox } from "./checkbox";

/**
 * CatalogCheckboxGroup
 * @param {Array} catalog - Array of catalog items (with id, key, ES, activo?)
 * @param {Array} selectedIds - Array of selected IDs
 * @param {Function} onChange - Called with new array of selected IDs
 * @param {String} label - Optional label
 *
 * Items with `activo === false` are hidden UNLESS the venue already has them
 * selected — in that case they remain visible with an "(Inactivo)" badge so
 * the owner knows the option is being retired and can uncheck it.
 */
export default function CatalogCheckboxGroup({ catalog, selectedIds = [], onChange, label }) {
  const handleToggle = (id, checked) => {
    if (checked) {
      onChange([...selectedIds, id]);
    } else {
      onChange(selectedIds.filter((item) => item !== id));
    }
  };

  const isItemSelected = (item) => selectedIds.includes(Number(item.id));
  const visibleItems = catalog.filter(
    (item) => item.activo !== false || isItemSelected(item),
  );

  return (
    <div className="space-y-2">
      {label && <div className="font-semibold mb-2">{label}</div>}
      {visibleItems.map((item) => {
        const isChecked = isItemSelected(item);
        const isInactive = item.activo === false;
        return (
          <div key={item.id} className="flex items-center gap-2">
            <Checkbox
              color="accent"
              checked={isChecked}
              onChange={(checked) => handleToggle(Number(item.id), checked)}
            />
            <span
              className="cursor-pointer select-none"
              onClick={() => handleToggle(Number(item.id), !isChecked)}
            >
              {item.ES || item.key}
            </span>
            {isInactive && (
              <span className="ml-1 inline-flex items-center rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-medium uppercase tracking-wide text-amber-800">
                Inactivo
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
}
